import {css} from "@panda/css";

const HIDE_AFTER_MS = 700;
const FADE_MS = 300;
const THUMB_PX = 8;
const MIN_THUMB_PX = 24;
const INSTALL_KEY = "__prettyScroll";

export const prettyScrollProps = {"data-pretty-scroll": ""} as const;

export const prettyScroll = css.raw({
    overflowY: "auto",
    position: "relative",
    scrollbarWidth: "none"
});

type Axis = "x" | "y";

const hideTimers = new WeakMap<HTMLElement, number>();
const thumbs = new WeakMap<HTMLElement, Partial<Record<Axis, HTMLElement>>>();

const ensureThumb = (node: HTMLElement, axis: Axis) => {
    const current = thumbs.get(node) ?? {};
    const existing = current[axis];

    if (existing) {
        return existing;
    }

    const thumb = document.createElement("div");

    thumb.dataset.prettyScrollThumb = axis;
    thumb.setAttribute("aria-hidden", "true");
    thumb.style.position = "absolute";
    thumb.style.pointerEvents = "none";
    node.appendChild(thumb);
    thumbs.set(node, {...current, [axis]: thumb});

    return thumb;
};

const placeThumb = (node: HTMLElement, axis: Axis) => {
    const viewport = axis === "y" ? node.clientHeight : node.clientWidth;
    const scrollSize = axis === "y" ? node.scrollHeight : node.scrollWidth;
    const overflow = scrollSize - viewport;
    const existing = thumbs.get(node)?.[axis];

    if (overflow <= 1 || viewport <= 0) {
        existing?.removeAttribute("data-visible");
        return;
    }

    const size = Math.min(viewport, Math.max(Math.floor((viewport / scrollSize) * viewport), Math.min(MIN_THUMB_PX, viewport)));
    const maxOffset = Math.max(viewport - size - 1, 0);
    const scroll = axis === "y" ? node.scrollTop : node.scrollLeft;
    const offset = (scroll / overflow) * maxOffset;
    const thumb = ensureThumb(node, axis);

    if (axis === "y") {
        thumb.style.top = `${node.scrollTop + offset}px`;
        thumb.style.right = "0";
        thumb.style.left = "auto";
        thumb.style.width = `${THUMB_PX}px`;
        thumb.style.height = `${size}px`;
    } else {
        thumb.style.left = `${node.scrollLeft + offset}px`;
        thumb.style.top = `${node.scrollTop + viewport - THUMB_PX}px`;
        thumb.style.right = "auto";
        thumb.style.width = `${size}px`;
        thumb.style.height = `${THUMB_PX}px`;
    }

    thumb.dataset.visible = "";
};

const revealThumb = (node: HTMLElement) => {
    placeThumb(node, "y");
    placeThumb(node, "x");

    const pending = hideTimers.get(node);

    if (pending != null) {
        window.clearTimeout(pending);
    }

    hideTimers.set(
        node,
        window.setTimeout(() => {
            const pair = thumbs.get(node);

            pair?.x?.removeAttribute("data-visible");
            pair?.y?.removeAttribute("data-visible");
            hideTimers.delete(node);
        }, HIDE_AFTER_MS)
    );
};

const onScroll = (event: Event) => {
    const node = event.target;

    if (!(node instanceof HTMLElement) || !node.hasAttribute("data-pretty-scroll")) {
        return;
    }

    revealThumb(node);
};

const installPrettyScroll = () => {
    if (typeof document === "undefined") {
        return;
    }

    const runtime = window as Window & {[INSTALL_KEY]?: () => void};

    runtime[INSTALL_KEY]?.();

    let style = document.getElementById("pretty-scroll-thumb");

    if (!style) {
        style = document.createElement("style");
        style.id = "pretty-scroll-thumb";
        document.head.appendChild(style);
    }

    style.textContent = `[data-pretty-scroll-thumb]{position:absolute;pointer-events:none;border-radius:100px;background:#ccc;opacity:0;transition:opacity ${FADE_MS}ms ease;z-index:var(--zIndex-base)}[data-pretty-scroll-thumb][data-visible]{opacity:1}`;

    document.addEventListener("scroll", onScroll, {capture: true, passive: true});

    runtime[INSTALL_KEY] = () => {
        document.removeEventListener("scroll", onScroll, true);
    };
};

installPrettyScroll();
import {css} from "@panda/css";

const HIDE_AFTER_MS = 700;
const FADE_MS = 300;
const THUMB_PX = 8;
const MIN_THUMB_PX = 24;
const INSTALL_KEY = "__prettyScroll";

export const prettyScrollProps = {"data-pretty-scroll": ""} as const;

export const prettyScroll = css.raw({
    overflowY: "auto",
    position: "relative",
    scrollbarWidth: "none"
});

type Axis = "x" | "y";

const hideTimers = new WeakMap<HTMLElement, number>();
const thumbs = new WeakMap<HTMLElement, Partial<Record<Axis, HTMLElement>>>();

const ensureThumb = (node: HTMLElement, axis: Axis) => {
    const current = thumbs.get(node) ?? {};
    const existing = current[axis];

    if (existing) {
        return existing;
    }

    const thumb = document.createElement("div");

    thumb.dataset.prettyScrollThumb = axis;
    thumb.setAttribute("aria-hidden", "true");
    thumb.style.position = "absolute";
    thumb.style.pointerEvents = "none";
    node.appendChild(thumb);
    thumbs.set(node, {...current, [axis]: thumb});

    return thumb;
};

const placeThumb = (node: HTMLElement, axis: Axis) => {
    const viewport = axis === "y" ? node.clientHeight : node.clientWidth;
    const scrollSize = axis === "y" ? node.scrollHeight : node.scrollWidth;
    const overflow = scrollSize - viewport;
    const existing = thumbs.get(node)?.[axis];

    if (overflow <= 1 || viewport <= 0) {
        existing?.removeAttribute("data-visible");
        return;
    }

    const size = Math.min(viewport, Math.max(Math.floor((viewport / scrollSize) * viewport), Math.min(MIN_THUMB_PX, viewport)));
    const maxOffset = Math.max(viewport - size - 1, 0);
    const scroll = axis === "y" ? node.scrollTop : node.scrollLeft;
    const offset = (scroll / overflow) * maxOffset;
    const thumb = ensureThumb(node, axis);

    if (axis === "y") {
        thumb.style.top = `${node.scrollTop + offset}px`;
        thumb.style.right = "0";
        thumb.style.left = "auto";
        thumb.style.width = `${THUMB_PX}px`;
        thumb.style.height = `${size}px`;
    } else {
        thumb.style.left = `${node.scrollLeft + offset}px`;
        thumb.style.top = `${node.scrollTop + viewport - THUMB_PX}px`;
        thumb.style.right = "auto";
        thumb.style.width = `${size}px`;
        thumb.style.height = `${THUMB_PX}px`;
    }

    thumb.dataset.visible = "";
};

const revealThumb = (node: HTMLElement) => {
    placeThumb(node, "y");
    placeThumb(node, "x");

    const pending = hideTimers.get(node);

    if (pending != null) {
        window.clearTimeout(pending);
    }

    hideTimers.set(
        node,
        window.setTimeout(() => {
            const pair = thumbs.get(node);

            pair?.x?.removeAttribute("data-visible");
            pair?.y?.removeAttribute("data-visible");
            hideTimers.delete(node);
        }, HIDE_AFTER_MS)
    );
};

const onScroll = (event: Event) => {
    const node = event.target;

    if (!(node instanceof HTMLElement) || !node.hasAttribute("data-pretty-scroll")) {
        return;
    }

    revealThumb(node);
};

const installPrettyScroll = () => {
    if (typeof document === "undefined") {
        return;
    }

    const runtime = window as Window & {[INSTALL_KEY]?: () => void};

    runtime[INSTALL_KEY]?.();

    let style = document.getElementById("pretty-scroll-thumb");

    if (!style) {
        style = document.createElement("style");
        style.id = "pretty-scroll-thumb";
        document.head.appendChild(style);
    }

    style.textContent = `[data-pretty-scroll-thumb]{position:absolute;pointer-events:none;border-radius:100px;background:#ccc;opacity:0;transition:opacity ${FADE_MS}ms ease;z-index:var(--zIndex-base)}[data-pretty-scroll-thumb][data-visible]{opacity:1}`;

    document.addEventListener("scroll", onScroll, {capture: true, passive: true});

    runtime[INSTALL_KEY] = () => {
        document.removeEventListener("scroll", onScroll, true);
    };
};

installPrettyScroll();
